import React, { useState } from "react";
import {
  Grid,
  Paper,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import HeaderApp from "../../../components/LoginPages/header";
import BottomImage from "../../../components/LoginPages/bottomimage";
import { esignToolApi } from "../../../services/esignApi";

const SuperadminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [helperText, setHelperText] = useState({ email: "", password: "" });

  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  };

  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = { email: "", password: "" };
    let newHelperText = { email: "", password: "" };
    let isValid = true;

    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
      newErrors.email = "Invalid email address";
      newHelperText.email = "Invalid email address";
      isValid = false;
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
      newHelperText.password = "Password is required";
      isValid = false;
    } else if (password.length < 5) {
      newErrors.password = "Password must be atleast 5 characters.";
      newHelperText.password = "Password must be atleast 5 characters.";
      isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setEmail(value);
      // Reset error if valid
      if (!validateEmail(value) && value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Invalid email address",
        }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          email: "Invalid email address",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
        setHelperText((prevHelperText) => ({ ...prevHelperText, email: "" }));
      }
    }
  };

  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true);

      const loginData = {
        email: email,
        password: password,
      };

      try {
        // const response = await esignToolApi.superLogin(loginData);
        // console.log("response", response);
        // localStorage.setItem("superToken", response.token);
        localStorage.setItem("superToken", "asdsfdgf");
        navigate("/superdashboard");
      } catch (error) {
        console.error("Login failed:", error);
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          display: "flex",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
        }}
      >
        <Grid item xs={12} sm={8} md={3.5}>
          <Paper
            elevation={3}
            sx={{
              padding: "1.6em 3em",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              background: "#fffff",
              position: "relative",
              zIndex: 1,
              borderRadius: "15px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: 700, fontSize: "24px", mb: 3 }}
            >
              Login
            </Typography>

            <TextField
              placeholder="Email address"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              value={email}
              onChange={(e) => {
                handleChange(e);
              }}
              error={!!errors.email}
              sx={{
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.email ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/mail.svg`}
                      alt="Email Icon"
                      style={{ width: 18, height: 18 }}
                    />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: "10px",
                  height: 45,
                  fontSize: "16px",
                  fontWeight: email ? "600" : "400",
                },
              }}
            />

            {!!errors.email && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto",
                }}
              >
                {helperText.email}
              </Typography>
            )}

            <TextField
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
                setHelperText((prevHelperText) => ({
                  ...prevHelperText,
                  password: "",
                }));
              }}
              error={!!errors.password}
              sx={{
                mt: 2,
                boxSizing: "border-box",
                borderRadius: "10px",
                backgroundColor: "#fff",
                borderColor: "#C0C0C0",
                borderWidth: "5px",
                "& .MuiOutlinedInput-root": {
                  borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  backgroundColor: errors.password ? "#FFF1F1" : "none",
                  "&:hover fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                  },
                },
                "& .MuiFormHelperText-root": {
                  color: "#FF6666",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/lock.svg`}
                      alt="Pass Icon"
                      style={{ width: 18, height: 18 }}
                    />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      onClick={handlePasswordToggle}
                      sx={{
                        cursor: "pointer",
                        color: "#185CB7",
                        fontSize: "15px",
                        fontWeight: 600,
                        transition: "color 0.2s ease-in-out",
                        textDecoration: "none",
                      }}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </Typography>
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: "10px",
                  height: 45,
                  fontSize: "16px",
                  fontWeight: password ? "600" : "400",
                  "& input::-ms-reveal, & input::-ms-clear": {
                    display: "none",
                  },
                },
              }}
            />

            {!!errors.password && (
              <Typography
                sx={{
                  color: "#FF6666",
                  fontSize: "12px",
                  mt: 0.5,
                  mb: 0,
                  marginRight: "auto",
                }}
              >
                {helperText.password}
              </Typography>
            )}

            <Button
              variant="contained"
              sx={{
                mt: 2,
                mb: 2,
                width: "100%",
                height: 45,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                fontWeight: "600",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={handleSubmit}
            >
              Login
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <BottomImage />
    </>
  );
};

export default SuperadminLogin;
